export const CREATE_DEDUCTION = "CREATE_DEDUCTION";
export const FETCH_DEDUCTIONS = "FETCH_DEDUCTIONS";
export const FETCH_DEDUCTION = "FETCH_DEDUCTION";
export const EDIT_DEDUCTION = "EDIT_DEDUCTION";
export const DELETE_DEDUCTION = "DELETE_DEDUCTION";
